import React from 'react';
import { Typography } from 'antd';
import injectSheet from 'react-jss';
import { Link } from 'react-router-dom';
import CupcakeLogoType from './CupcakeLogotype';
import { classesPropType } from './prop-types';
import routes from '../routes';

const { Paragraph } = Typography;

const SUPPORT_EMAIL = 'cupcake-support@googlegroups.com';

const styles = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logotype: {
    marginBottom: '24px',
  },
  text: {
    textAlign: 'center',
  },
};

function Support({ classes }) {
  return (
    <div className={classes.container}>
      <Link to={routes.home}>
        <CupcakeLogoType className={classes.logotype} />
      </Link>
      <Paragraph className={classes.text}>
        Reach us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> if you have any comments or trouble using the app.
      </Paragraph>
    </div>
  );
}

Support.propTypes = {
  classes: classesPropType.isRequired,
};

export default injectSheet(styles)(Support);
